import React, { useState } from 'react';

import { StyledImage } from './PlayImage.styles';

type Props = {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    inView?: boolean;
    ssr?: boolean;
    sizes?: string;
    srcSet?: string;
    blurred?: boolean;
    showPlaceholder?: boolean;
    opacity?: number;
};

const Image = ({
    src,
    width,
    height,
    inView,
    ssr,
    sizes,
    srcSet,
    alt,
    blurred,
    showPlaceholder,
    opacity,
}: Props): JSX.Element => {
    const [error, setError] = useState<boolean>(false);

    const as = error || !inView ? 'div' : 'img';

    return (
        <StyledImage<typeof as>
            as={as}
            key={src}
            // @ts-ignore ('div' does not have the width prop)
            width={width}
            onError={() => setError(true)}
            height={height}
            data-src={src}
            src={src}
            srcSet={srcSet}
            sizes={sizes}
            ssr={ssr}
            alt={alt}
            inView={inView}
            blurred={blurred}
            showPlaceholderImage={showPlaceholder}
            opacity={opacity}
        />
    );
};

export default Image;
